
<div #divcontainer>
  <app-toggle-on>
    <div class="" [ngClass]="['imageBg']">
      <div class="imageDeleteOverlay">
        <i class="fas fa-trash-alt" style="font-size: 2vh; padding: 0.5vh; height: 2vh;" (click)="deleteImage($event)"></i>
      </div>
      <img *ngIf="!defaultImage" [src]="'data:image/jpg;base64,'+ image.data" class="" (error)="defaultImage=true" style="height: 100%; position: absolute">      
      <i *ngIf="defaultImage" class="far fa-image" style="font-size: 8vh; width: 10vh; background-color: #f0f0f0"></i>
    </div>
  </app-toggle-on>

  <app-toggle-off>
    <div *ngIf="!defaultImage"
         class="readytodrag{{image.id}}"
         [attr.data-imageid]="image.id "
         [ngClass]="['imageBg']">

      <img [src]="'data:image/jpg;base64,'+ image.data" class="" (error)="defaultImage=true" style="height: 100%">
    </div>
    <div *ngIf="defaultImage"
         [attr.data-imageid]="image.id "
         [ngClass]="['imageBg']">
      <i class="far fa-image" style="font-size: 8vh; width: 10vh; background-color: #f0f0f0"></i>
    </div>
  </app-toggle-off>
</div>

